/**
 * 搜索弹窗 GA4 埋点
 *
 * 事件名均为 search，通过 search_type 区分：
 * - normal search：回车、底部 Search 按钮
 * - recommend search：联想下拉项
 * - recommendation banner：Recommendations 区（banner / 产品卡片 / 文字链）
 */
import { ready } from "//hotroborocbargains.com/cdn/shop/t/148/assets/GA4-track-directive-core.js?vTrack=202605191002&v=173442715763267816081786948753";
import { trackReport } from "//hotroborocbargains.com/cdn/shop/t/148/assets/GA4-track-directive-report.js?vTrack=202605191002&v=104115401213510859531783586306";

const MODAL_ID = 'roSearchModal';
const INPUT_SELECTOR = '#roSearchContent .ro-input__input';

/** 与 roborock-search-modal.liquid DOM 一一对应 */
const RECOMMENDATION_BANNER_SELECTOR =
  'a.ro-search-recommend, a.search-recommend-item';
const RECOMMEND_SEARCH_SELECTOR = 'a.search-results-item';
const NORMAL_SEARCH_BTN_SELECTOR = 'a.search-btn';

let initialized = false;

/**
 * 判断点击是否落在某区域内的目标链接上。
 * root.contains 限定范围；link.matches 只用「标签+类名」，避免 `#父级 a.xxx` 复合选择器匹配不准。
 */
function isLinkIn(root, link, selector) {
  return !!root && !!link && root.contains(link) && link.matches(selector);
}

/**
 * 读取弹窗内搜索词
 * @param {HTMLElement} modal
 * @returns {string}
 */
function getSearchTerm(modal) {
  const input = modal.querySelector(INPUT_SELECTOR);
  return input ? input.value.trim() : '';
}

/**
 * 链接展示文案（含高亮 mark 内的文字，不含 HTML 标签）
 * @param {HTMLAnchorElement} link
 * @returns {string}
 */
function getLinkText(link) {
  return (link.getAttribute('aria-label') || link.textContent || '').trim();
}

/**
 * 上报 search 事件
 * @param {string} searchType
 * @param {string} searchTerm
 * @param {Record<string, string>} [extra]
 */
function pushSearchEvent(searchType, searchTerm, extra = {}) {
  trackReport({
    event_name: 'search',
    event_parameters: Object.assign(
      {
        search_type: searchType,
        search_term: searchTerm,
      },
      extra
    ),
  });
}

/**
 * 绑定弹窗内全部搜索相关埋点（仅初始化一次）
 */
function initSearchModalGa4() {
  if (initialized) return;

  const modal = document.getElementById(MODAL_ID);
  if (!modal) return;

  const input = modal.querySelector(INPUT_SELECTOR);
  if (!input) return;

  initialized = true;

  const recommendRoot = modal.querySelector('#SearchRecommend');
  const resultsRoot = modal.querySelector('#SearchResults');

  // normal search：回车（非空），不阻止默认跳转
  input.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    const searchTerm = getSearchTerm(modal);
    if (!searchTerm) return;
    pushSearchEvent('normal search', searchTerm);
  });

  // 捕获阶段：在 <a> 跳转前完成上报
  modal.addEventListener(
    'click',
    function (event) {
      const link = event.target.closest('a');
      if (!link) return;

      const searchTerm = getSearchTerm(modal);
      // Recommendations 区：banner / 产品卡片 / 文字链
      if (isLinkIn(recommendRoot, link, RECOMMENDATION_BANNER_SELECTOR)) {
        pushSearchEvent('recommendation banner', searchTerm, {
          product_name: link.href || '',
        });
        return;
      }

      // 联想下拉项：search_term 为被点击条目的完整文案，非输入框关键词
      if (isLinkIn(resultsRoot, link, RECOMMEND_SEARCH_SELECTOR)) {
        pushSearchEvent('recommend search', getLinkText(link));
        return;
      }

      // 底部 Search 按钮
      if (isLinkIn(resultsRoot, link, NORMAL_SEARCH_BTN_SELECTOR)) {
        if (!searchTerm) return;
        pushSearchEvent('normal search', searchTerm);
      }
    },
    true
  );
}

ready(initSearchModalGa4);
